import script from "./ProfilePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePage.vue?vue&type=script&lang=ts&setup=true"

import "./ProfilePage.vue?vue&type=style&index=0&id=25a52312&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a52312"]])

export default __exports__